import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { MessageTable } from '../components/digisac/MessageTable';
import { ScheduleTable } from '../components/digisac/ScheduleTable';
import { NewMessageModal } from '../components/digisac/NewMessageModal';

type Tab = 'messages' | 'schedules';

const DigisacPage: React.FC = () => {
  const [tab, setTab] = useState<Tab>('messages');
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => {
    setRefreshKey(k => k + 1);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
              Digisac — WhatsApp
            </h1>
            <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
              Envie mensagens e gerencie agendamentos via WhatsApp
            </p>
          </div>
          <button
            onClick={() => setModalOpen(true)}
            className="px-3 py-1.5 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity"
            style={{ backgroundColor: '#7A61B2' }}
          >
            + Nova Mensagem
          </button>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-4">
          <button
            onClick={() => setTab('messages')}
            className="px-4 py-1.5 text-xs rounded font-medium transition-colors"
            style={tab === 'messages'
              ? { backgroundColor: '#7A61B2', color: '#fff' }
              : { backgroundColor: '#E9E3F5', color: '#3d2b56' }}
          >
            Mensagens
          </button>
          <button
            onClick={() => setTab('schedules')}
            className="px-4 py-1.5 text-xs rounded font-medium transition-colors"
            style={tab === 'schedules'
              ? { backgroundColor: '#7A61B2', color: '#fff' }
              : { backgroundColor: '#E9E3F5', color: '#3d2b56' }}
          >
            Agendamentos
          </button>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          {tab === 'messages' ? (
            <MessageTable refreshKey={refreshKey} />
          ) : (
            <ScheduleTable
              refreshKey={refreshKey}
              onCancelled={() => setRefreshKey(k => k + 1)}
            />
          )}
        </div>
      </div>

      {modalOpen && (
        <NewMessageModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default DigisacPage;
